/* NOTE: 
Ensured I changed email is always lowercase: 
(1) onChange → input value, 
(2) onSubmit → final payload */

import PropTypes from "prop-types";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Button,
  Spinner
} from "reactstrap";

//redux
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import { useFormik } from "formik";
import * as Yup from "yup";

// action
import { userForgetPassword } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import { createSelector } from "reselect";
import ParticlesAuth from "./ParticlesAuth";
import { useEffect, useState } from "react";
import { resetForgetPasswordFlag, resetResetPasswordFlag, userForgetPasswordSuccess } from "slices/auth/forgetpwd/reducer";
import { toast, ToastContainer } from "react-toastify";

const ForgetPasswordPage = (props: any) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    dispatch(userForgetPasswordSuccess(""));
  }, []);

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: "",
      email: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().trim().required("Please Enter Your Username"),
      email: Yup.string().trim().required("Please Enter Your Email"),
    }),
    onSubmit: (values, { resetForm }) => {
      dispatch(userForgetPassword(values, props.router.navigate));
      setLoader(true)
      //resetForm();
    },
  });




  const selectLayoutState = (state: any) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(selectLayoutState, (state) => ({
    forgetError: state.forgetError,
    forgetSuccessMsg: state.forgetSuccessMsg,
    isForgetError: state.isForgetError,
  }));
  // Inside your component
  const { forgetError, forgetSuccessMsg,isForgetError } = useSelector(selectLayoutProperties);

  useEffect(() => {
    if (forgetSuccessMsg) {
      toast.success(forgetSuccessMsg, {
        position: "top-right",
        hideProgressBar: false,
        className: "",
        progress: undefined,
        toastId: "reset-success",
      });
      dispatch(resetForgetPasswordFlag())
      setTimeout(() => {
        props.router.navigate("/reset-password");
      },1000);
    }

    if (forgetError) {
      toast.error(forgetError, {
        position: "top-right",
        hideProgressBar: false,
        className: "bg-error fw-semibold",
        progress: undefined,
        toastId: "reset-error",
      });
      dispatch(resetForgetPasswordFlag())
    }
  }, [forgetSuccessMsg, forgetError]);

  useEffect(() => {
    if (isForgetError) {
      dispatch(resetResetPasswordFlag())
        setLoader(false)
    }
  }, [dispatch, isForgetError])

  document.title = "Forgot Password";
  return (
    <ParticlesAuth>
      <div className="auth-page-content d-flex justify-content-center align-items-center min-vh-100">
        <Container>
          {/* <ToastContainer autoClose={3000} limit={1} /> */}
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4 card-light">
                <CardBody className="p-4">
                  <div className="mx-2 mt-2">
                    <h5 className="text-primary">Forgot your password?</h5>
                    <p className="text-muted">Reset password with Amanat</p>
                    <div className="text-center">
                      <i className="ri-mail-send-line display-5 text-secondary mb-3"></i>
                    </div>
                  </div>

                  <Alert
                    className="border-0 alert-warning text-center mb-2 mx-2"
                    role="alert"
                  >
                    Enter your email and instructions will be sent to you!
                  </Alert>
                  <div className="p-2">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Username</Label>
                        <Input
                          name="username"
                          className="form-control"
                          placeholder="Enter Username"
                          type="text"
                          onChange={(e) => {
                            validation.setFieldValue("username", e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.username || ""}
                          invalid={
                            validation.touched.username && validation.errors.username
                              ? true
                              : false
                          }
                        />
                        {validation.touched.username && validation.errors.username ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.username}</div>
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={(e) => {
                            validation.setFieldValue("email", e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.email}</div>
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <Button className="btn btn-primary w-100" type="submit" color="primary" disabled={loader && true}>
                          {loader && (
                            <Spinner size="sm" className="me-2">
                              {" "}
                              Loading...{" "}
                            </Spinner>
                          )}
                          Send OTP
                        </Button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">
                  Wait, I remember my password...{" "}
                  <Link
                    to="/login"
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    {" "}
                    Click here{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
